import { Chain } from '@ankr.com/chains-list';

import { AdvancedApiInfoTabs } from 'domains/chains/screens/ChainPage/components/ChainItemSections/components/AdvancedApiInfoTabs';
import { ChainItemHeader } from 'domains/chains/screens/ChainPage/components/ChainItemHeader';
import { ChainProtocolContext } from 'domains/chains/screens/ChainPage/constants/ChainProtocolContext';
import { MultiChainBenefits } from 'modules/common/components/GetStartedSection/components/MultichainBenefits';
import { UpgradeAccountDialog } from 'modules/common/components/UpgradeAccountDialog';
import { UsageDataSection } from 'domains/chains/screens/ChainPage/components/UsageDataSection';
import { isMultichain } from 'modules/chains/utils/isMultichain';
import { useDialog } from 'modules/common/hooks/useDialog';
import { useRedirectToAdvancedApi } from 'domains/chains/screens/ChainPage/hooks/useRedirectToAdvancedApi';

import { usePublicChainItem } from './hooks/usePublicChainItem';

export interface ChainItemProps {
  chainData: Chain;
}

export const PublicChainItem = ({ chainData }: ChainItemProps) => {
  const {
    isOpened: isPromoDialogOpened,
    onClose: onPromoDialogClose,
    onOpen: onOpenUpgradeModal,
  } = useDialog();

  const { chain, chainProtocolContext, headerContent } = usePublicChainItem({
    chain: chainData,
    onBlockedTabClick: onOpenUpgradeModal,
    onOpenUpgradeModal,
  });

  useRedirectToAdvancedApi();

  return (
    <ChainProtocolContext.Provider value={chainProtocolContext}>
      <ChainItemHeader headerContent={headerContent} />
      {isMultichain(chain.id) && (
        <>
          <AdvancedApiInfoTabs />
          <MultiChainBenefits />
        </>
      )}
      <UsageDataSection chain={chain} />
      <UpgradeAccountDialog
        isOpened={isPromoDialogOpened}
        onClose={onPromoDialogClose}
      />
    </ChainProtocolContext.Provider>
  );
};
